export const appSettings = {
  //'planning_files_url': 'http://139.59.65.145:6012',
  'planning_files_url': 'https://bmr-planning-be.schemaxtech.in/erpx',
  //'masters_url': 'http://139.59.65.145:6001/erpx',
  'masters_url': 'https://bmr-masters-be.schemaxtech.in/erpx',
  //'sales_url': 'http://139.59.65.145:6002/erpx',
  'sales_url': 'https://bmr-sale-service-be.schemaxtech.in/erpx',
  //'procure_url': 'http://139.59.65.145:6003/erpx',
  'procure_url': 'https://bmr-procurement-service-be.schemaxtech.in/erpx',
  //'warehouse_url': 'http://139.59.65.145:6004/erpx',
  'warehouse_url': 'https://bmr-warehouse-service-be.schemaxtech.in/erpx',
  //'logistics_url': 'http://139.59.65.145:6005/erpx',
  'logistics_url': 'https://bmr-logistics-be.schemaxtech.in/erpx',
  //'ums_url': 'http://139.59.65.145:6006/erpx',
  'ums_url': 'https://bmr-backend-be.schemaxtech.in/erpx',
  //'rm_procure_url': 'http://139.59.65.145:6007/erpx',
  'rm_procure_url': 'https://bmr-rmprocurement-be.schemaxtech.in/erpx',
  //'transport_url': 'http://139.59.65.145:6008/erpx',
  'transport_url': 'https://bmr-transportation-be.schemaxtech.in/erpx',
  //'production_url': 'http://139.59.65.145:6009/erpx',
  'production_url': 'https://bmr-production-be.schemaxtech.in/erpx',
  'assets_url': 'http://139.59.65.145:6010/erpx',
  //'hrms_url': 'http://139.59.65.145:6011/erpx',
  'hrms_url': 'https://bmr-hrms-be.schemaxtech.in/erpx',
  //'planning_url': 'http://139.59.65.145:6012/erpx',
  'planning_url': 'https://bmr-planning-be.schemaxtech.in/erpx',
  //'anlytics_url': 'http://139.59.65.145:6013/erpx',
  'anlytics_url': 'https://bmr-analytics-be.schemaxtech.in/erpx',
  'bulljobs_url': 'http://139.59.65.145:6014/erpx',
  'bulljobs_manager_url': 'http://139.59.65.145:6015/erpx',
  'vms_url':'http://139.59.65.145:6016/erpx',
  'cms_url': 'http://139.59.65.145:6017/erpx',
  //'logs_url':'http://139.59.65.145:6018/erpx', 
  'logs_url':'https://bmr-user-logs-be.schemaxtech.in/erpx', 
  //'enquiry_url':'http://139.59.65.145:6019/erpx',
  'enquiry_url':'https://bmr-enquiry-management-be.schemaxtech.in/erpx',
  //'finance_url':'http://139.59.65.145:6020/erpx',
  'finance_url':'https://bmr-finance-be.schemaxtech.in/erpx',
  //'dashboard_url':'http://143.198.233.137/aquadashboard_app/#',
  'dashboard_url':'https://bmr-dashboards.schemaxtech.in/#',
  'dbhost': '139.59.65.145',
  'dbuser': 'bmr_prod_user',
  'dbpassword': 'bmr@!123',
  // 'analytics_db_port': 3306,
  'analytics_db': 'erpx_dev_analytics',
  'masters_db': 'erpx_dev_masters',
  'sales_db': 'erpx_dev_sales',
  'procure_db': 'erpx_dev_procurement',
  'warehouse_db': 'erpx_dev_warehouse',
  'logistics_db': 'erpx_dev_logistics',
  'ums_db': 'erpx_dev_ums',
  'rm_procure_db': 'erpx_dev_rm_procurement',
  'transport_db': 'erpx_dev_transport',
  'production_db': 'erpx_dev_production',
  'assets_db': 'erpx_dev_assets',
  'hrms_db': 'erpx_dev_hrms',
  'planning_db': 'erpx_dev_planning',
  'vms_db': 'visitor_management',
  'cms_db': 'erpx_dev_cms',
  'logs_db':'erpx_dev_logs',
  'whatsapp_db':'whatsapp_bi',
  'enquiry_db':'erpx_dev_enquiries',
  'finance_db':'erpx_dev_finance',
  'masters_port': '6001',
  'sales_port': '6002',
  'procurement_port': '6003',
  'warehouse_port': '6004',
  'logistics_port': '6005',
  'ums_port': '6006',
  'rm_procurement_port': '6007',
  'transport_port': '6008',
  'production_port': '6009',
  'assets_port': '6010',
  'hrms_port': '6011',
  'planning_port': '6012',
  'analytics_port': '6013',
  'bulljobs_port': '6014',
  'bulljobs_manager_port': '6014',
  'vms_port':'6016',
  'cms_port': '6017',
  'logs_port':'6018',
  'enquiry_port':'6019',
  'finance_port':'6020',
  // 'file_upload_path': 'http://139.59.65.145/erpx/dist/apps/services/sale-service/', // live 
  'file_upload_path': 'http://139.59.65.145/bmr_live/dist/apps/services/', // dev instance
  // 'logistics_doc_upload_path': 'http://139.59.65.145/erpx/dist/apps/services/logistics/', // live 
  'logistics_doc_upload_path': 'http://139.59.65.145/bmr_live/dist/apps/services/logistics/', // dev instance
  // 'brand_file_path': 'http://139.59.65.145/erpx/dist/apps/services/masters/', // live
  'brand_file_path': 'http://139.59.65.145/bmr_live/dist/apps/services/masters/', // dev instance
  // 'whatsapp_redirection_dev_url': 'http://dev.schemaxtech.in/#',
  // 'whatsapp_redirection_live_url': 'http://uat.schemaxtech.in/#',
  'whatsapp_redirection_url': 'http://dev.schemaxtech.in/#',
  'whatsapp_notification_url': 'http://139.59.65.145:3000',
  'whatsapp_broadcast_url': 'http://206.189.138.212:3235/api',
 'tally_upload_files':"http://139.59.65.145/bmr_live/tally-integration",
 
}

export default appSettings;

